import { Aggregated_Audience_Operator } from '@occc/graphql';
import { CombinedAudiencesValues } from './types';

export const combinedAudiencesInitialValues: CombinedAudiencesValues = {
  audiences: [],
  operator: Aggregated_Audience_Operator.InAll,
};

export const titleByCombinedAudiencesOperator: Record<Aggregated_Audience_Operator, string> = {
  [Aggregated_Audience_Operator.InAll]: 'In All',
  [Aggregated_Audience_Operator.InAny]: 'In Any',
};
